import { render, staticRenderFns } from "./PreSend.vue?vue&type=template&id=5e8eaa3a"
import script from "./PreSend.vue?vue&type=script&lang=js"
export * from "./PreSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports